import { render, staticRenderFns } from "./shop-products-search.vue?vue&type=template&id=a9625fa4&"
import script from "./shop-products-search.vue?vue&type=script&lang=js&"
export * from "./shop-products-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports